import { render } from "./FlowEditPage.vue?vue&type=template&id=b4a1c9f2"
import script from "./FlowEditPage.vue?vue&type=script&lang=js"
export * from "./FlowEditPage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__